/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum AlarmResolutionType {
  AutomaticRecovery = "automatic_recovery",
  ManualForceResolve = "manual_force_resolve",
  ManualFalsePositive = "manual_false_positive",
  ManualWontFix = "manual_wont_fix",
  SignalDeleted = "signal_deleted",
}

export function instanceOfAlarmResolutionType(value: any): boolean {
  for (const key in AlarmResolutionType) {
    if (Object.prototype.hasOwnProperty.call(AlarmResolutionType, key)) {
      if (
        AlarmResolutionType[key as keyof typeof AlarmResolutionType] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AlarmResolutionTypeFromJSON(json: any): AlarmResolutionType {
  return AlarmResolutionTypeFromJSONTyped(json, false);
}

export function AlarmResolutionTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AlarmResolutionType {
  return json as AlarmResolutionType;
}

export function AlarmResolutionTypeToJSON(
  value?: AlarmResolutionType | null,
): any {
  return value as any;
}

export function AlarmResolutionTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AlarmResolutionType {
  return value as AlarmResolutionType;
}
